import { Link, useNavigate } from "react-router-dom";
import icon1 from "../../images/icon1.png";
import icon2 from "../../images/icon2.png";
import icon3 from "../../images/icon3.png";
import { useDispatch, useSelector } from "react-redux";
import { useEffectOnce } from "../../hooks/useeffectonce";
import {
  disposePage,
  loadPlans,
  setProcessing,
} from "../../redux/slices/planslice";
import { notificationDurationMiddle } from "../../lib/utils";
import { apiErrorsHandler, getErrorMessages } from "../../api/httpclient";
import { addNotification } from "../../redux/slices/notificationsslice";
import { setCurrentPage } from "../../redux/slices/currentpageslice";
import { FederationId } from "../../settings";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

const Pricing = () => {
  const dispatch = useDispatch();
  const planState = useSelector((state) => state.plans);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const transformSize = (valueInMB) => {
    if (valueInMB < 1000)
      return t("static.pricing.megabytes", {
        value: Math.round(valueInMB * 100) / 100,
      });

    return t("static.pricing.gigabytes", {
      value: Math.round((valueInMB / 1000) * 100) / 100,
    });
  };

  const featureLabels = {
    alerts: "static.pricing.alerts",
    reports: "static.pricing.reports",
    "number of users": "static.pricing.users",
  };

  const periodLabels = {
    1: "static.pricing.day",
    2: "static.pricing.week",
    3: "static.pricing.month",
    4: "static.pricing.year",
  };

  /*initial page load*/
  useEffectOnce(() => {
    console.log(FederationId);
    if (FederationId == "") { 
      dispatch(loadPlans(t)).then(
        (response) => {},
        (err) => {
          //hide loader
          dispatch(setProcessing({ processing: false }));

          const handleResponseReceived = (
            state,
            dispatch,
            navigate,
            payload
          ) => {
            let errorMessages = payload?.data?.ErrorMessages;

            //notify with error
            if (!errorMessages || errorMessages.length == 0)
              dispatch(
                addNotification({
                  text: t("static.pricing.loading_errormessage"),
                  type: "error",
                  closable: true,
                  duration: notificationDurationMiddle,
                  position: "topRight",
                })
              );
            else {
              errorMessages = getErrorMessages(errorMessages, 1);
              dispatch(
                addNotification({
                  text: errorMessages[0],
                  type: "error",
                  closable: true,
                  duration: notificationDurationMiddle,
                  position: "topRight",
                })
              );
            }

            //go home
            navigate("/", { replace: true });
          };

          const handleUnhandled = (state, dispatch, navigate, payload) => {
            dispatch(
              addNotification({
                text: t("static.pricing.unknown_error"),
                type: "error",
                closable: true,
                duration: notificationDurationMiddle,
                position: "topRight",
              })
            );
            navigate("/", { replace: true });
          };

          apiErrorsHandler({}, dispatch, navigate, err, "/", {
            responseReceived: handleResponseReceived,
            unhandled: handleUnhandled,
          });
        }
      );
    }
    return () => {
      dispatch(setCurrentPage({ id: "", isDirty: false }));
      dispatch(disposePage(true));
    };
  }, []);
  /*initial load*/
  return (
    <>
      <div id="pricing" className="pricing-area ptb-100 pt-0">
        <div className="container">
          <div
            className="saas-section-title"
            data-aos="fade-up"
            data-aos-duration="800"
            data-aos-once="true"
            data-aos-delay="100"
          >
            <h2>{t("static.pricing.title")}</h2>
            <div className="bar"></div>
            <p>{t("static.pricing.subtitle")}</p>
          </div>

          <div className="row justify-content-center">
            {planState.plans &&
              planState?.plans?.map((p, index) => {
                if (p.IsPublic && p.IsActive) {
                  return (
                    <div
                      className="col-lg-4 col-md-6"
                      data-aos="fade-up"
                      data-aos-duration="800"
                      data-aos-once="true"
                      data-aos-delay="200"
                      key={index}
                    >
                      <div className="pricing-table">
                        <div className="pricing-header">
                          <div className="icon">
                            <img
                              src={icon1}
                              alt="icon"
                              width={85}
                              height={88}
                            />
                          </div>

                          <h3>{p.Name}</h3>
                        </div>

                        <ul className="pricing-features">
                          {p.SubscriptionFeatures?.map((f, index) => {
                            if (
                              f.Name.toLowerCase() == "alerts" ||
                              f.Name.toLowerCase() == "reports" ||
                              f.Name.toLowerCase() == "number of users"
                            ) {
                              return (
                                <li className="active" key={index}>
                                  {!f.Value
                                    ? t("static.pricing.unlimited")
                                    : t("static.pricing.up_to", {
                                        value: f.Value,
                                      })}{" "}
                                  {t(featureLabels[f.Name.toLowerCase()])}
                                </li>
                              );
                            }

                            if (f.Name == "MaximumSizeInMB") {
                              return (
                                <li className="active" key={index}>
                                  {!f.Value
                                    ? t("static.pricing.unlimited")
                                    : t("static.pricing.up_to", {
                                        value: transformSize(f.Value),
                                      })}{" "}
                                </li>
                              );
                            }
                          })}
                        </ul>

                        <div className="price">
                          ${p.Price}
                          <span>
                            {t("static.pricing.per")}{" "}
                            {t(periodLabels[p.PeriodType])}
                          </span>
                        </div>

                        <Link
                          to={`/onboarding?plan=${p.Id}`}
                          className="btn btn-primary"
                        >
                          {t("static.pricing.select")}
                        </Link>
                      </div>
                    </div>
                  );
                }
              })}
          </div>
          <div className="row justify-content-center">
            <div
              className="col-lg-12 col-md-12"
              data-aos="fade-up"
              data-aos-duration="800"
              data-aos-once="true"
              data-aos-delay="200"
            >
              <div className="pricing-table">
                <div className="pricing-header">
                  <div className="icon">
                    <img src={icon1} alt="icon" width={85} height={88} />
                  </div>

                  <h3>{t("static.pricing.entreprise")}</h3>
                </div>

                <ul className="pricing-features">
                  <li className="active">
                    {t("static.pricing.entreprise-reports")}
                  </li>
                  <li className="active">
                    {t("static.pricing.entreprise-alerts")}
                  </li>
                  <li className="active">
                    {t("static.pricing.entreprise-users")}
                  </li>
                  <li className="active">
                    {t("static.pricing.entreprise-storage")}
                  </li>
                </ul>

                <div className="price">
                  {t("static.pricing.price")}
                  <span>{t("static.pricing.duration-month")}</span>
                </div>

                <a href="#" className="btn btn-primary">
                  {t("static.pricing.select")}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Pricing;
